'use client'

import { useEffect, useState } from 'react'
import { validationQuestionForm } from '@/shared/validation/validationQuestionForm.js'
import SearchOrder from '@/features/questions-page/SearchOrder/index.js'
import {
    useCheckUserMutation,
    useSendFormMutation,
} from '@/shared/api-rtk/index.js'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'

export const QuestionForm = ({ order }) => {
    const { userInfo } = useGetIsAuthUser()
    const [checkProfile] = useCheckUserMutation()
    const [sendForm] = useSendFormMutation()

    const [submittedForm, setSubmittedForm] = useState({
        questionNumber: '',
        value: false,
    })
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        orderName: (order && order.id) || '',
        question: '',
    })
    const [errorsForm, setErrorsForm] = useState({
        name: false,
        email: false,
        orderName: false,
        question: false,
    })

    useEffect(() => {
        checkProfile(userInfo)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setFormData({
                        ...formData,
                        email: res.data.email,
                        name: `${res.data.firstname} ${res.data.lastname}`,
                    })
                }
            })
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault()

        //Проверка на валидность
        const validationForm = validationQuestionForm(formData, setErrorsForm)
        if (validationForm) {
            const dataForRequest = {
                ...formData,
                orderName: Number(formData.orderName),
            }
            sendForm(dataForRequest)
                .unwrap()
                .then((res) => {
                    // TODO: Поправить запрос - выкидывает ошибку (нет ID)
                    if (res.result === 'success') {
                        setSubmittedForm({
                            questionNumber: res.data,
                            value: true,
                        })
                    }
                })
                .catch((err) => {
                    // console.log(err)
                })
        }
    }

    return (
        <div className={'QuestionForm'}>
            {submittedForm.value && (
                <h2>
                    Форма отправлена №{submittedForm.questionNumber}! Мы ответим
                    вам в ближайшее время
                </h2>
            )}
            {!submittedForm.value && (
                <>
                    <div className={'info-text'}>
                        <img src="/icons/question-info-icon.svg" alt="icon" />
                        <p>
                            Задайте вопрос. Ответ приходит на почту в течение
                            1-3 дней и дублируется здесь.
                        </p>
                    </div>
                    <form className={'question-form'} onSubmit={handleSubmit}>
                        <div className={'input-container'}>
                            <input
                                type="text"
                                name="name"
                                className={`input ${
                                    errorsForm.name ? 'error-input' : ''
                                }`}
                                value={formData.name}
                                disabled={userInfo}
                                placeholder="Введите ваше имя"
                                onChange={(e) => {
                                    setFormData({
                                        ...formData,
                                        name: e.target.value,
                                    })
                                    setErrorsForm({
                                        ...errorsForm,
                                        name: false,
                                    })
                                }}
                            />
                            {errorsForm.name && (
                                <span className={'error-text'}>
                                    Введите ваше имя
                                </span>
                            )}
                        </div>
                        <div className={'input-container'}>
                            <input
                                type="email"
                                name="email"
                                className={`input ${
                                    errorsForm.email ? 'error-input' : ''
                                }`}
                                value={formData.email}
                                disabled={userInfo}
                                placeholder="Введите ваш E-Mail"
                                onChange={(e) => {
                                    setFormData({
                                        ...formData,
                                        email: e.target.value,
                                    })
                                    setErrorsForm({
                                        ...errorsForm,
                                        email: false,
                                    })
                                }}
                            />
                            {errorsForm.email && (
                                <span className={'error-text'}>
                                    Введите ваш E-Mail
                                </span>
                            )}
                        </div>
                        <div className={'input-container'}>
                            <SearchOrder
                                orderFromCard={order && order.name}
                                formData={formData}
                                setFormData={setFormData}
                                errorsForm={errorsForm}
                                setErrors={setErrorsForm}
                                errors={errorsForm}
                            />
                            {errorsForm.orderName && (
                                <span className={'error-text'}>
                                    Выберите товар из списка
                                </span>
                            )}
                        </div>
                        <div className={'input-container'}>
                            <textarea
                                name="question"
                                className={`input ${
                                    errorsForm.question ? 'error-input' : ''
                                }`}
                                placeholder="Введите ваше сообщение"
                                onChange={(e) => {
                                    setFormData({
                                        ...formData,
                                        question: e.target.value,
                                    })
                                    setErrorsForm({
                                        ...errorsForm,
                                        question: false,
                                    })
                                }}
                            />
                            {errorsForm.question && (
                                <span className={'error-text'}>
                                    Введите ваше сообщение
                                </span>
                            )}
                        </div>
                        <button type={'submit'}>Отправить форму</button>
                    </form>
                </>
            )}
        </div>
    )
}
